__webpack_require__.p = "/luxary-real-estate-react-responsive/";